import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions as patientActions } from '../../vAppointment/PatientDetails/actions/actions';
import { actions as guardianActions } from '../../vAppointment/PatientDetails/actions/guardianActions';
import { actions as loginActions } from '../../EntryPage/actions/actions';

import DesktopPopUp from '../../components/DesktopPopUp';
import styles from './loginDetailsPopup.module.css';
import { ReactComponent as Cross } from '../../svgs/close.svg';
import { ReactComponent as Arrow } from '../../svgs/rightarrow2.svg';
import { isDesktop } from '../../config';
import { go } from '../../routes';
import { getLoginPageURL } from '../../libs/utils';
import SignInForm from './SignInForm/index';
import PatientDetails from './PatientDetails/index';
import PatientSelection from './PatientSelection/index';
import TnC from '../../components/TnC/index';
import CtaButton from '../../components/CtaButton/index';
import GuardianDetails from './GuardianDetails';
import { height } from 'styled-system';

// interface Props {
//   firstName: string,
//   lastName: string,
//   dateOfBirth: string,
//   mobile: string,
//   hasGuardian: boolean,
//   hideTnC: Function,
//   patientDetails: PatientDetails,
//   fetchPatientDetailForSmokingAppointment: Function,
// };

// interface PatientDetails {
//   firstName: string,
//   lastName: string,
//   dateOfBirth: string,
//   mobile: string,
// };

export const LoginDetailsPopup = observer(
  ({
    match,
    guardianDetails,
    patientDetails,
    token,
    practice,
    error,
    isLoggedIn,
    addPatientDetails,
    addGuardianDetails,
    login,
    patientReady,
  }) => {
    var type = match.params.type;
    var orgId = match.params.orgId;

    const [showTnC, setShowTnC] = useState(true);
    const [patientValid, setPatientValid] = useState(false);
    const [guardianValid, setGuardianValid] = useState(false);

    const addPatientDetailsPatch = details => {
      addPatientDetails(details);
      // this.tempDetails = details;
    };

    const addGuardianDetailsPatch = details => {
      addGuardianDetails(details);
      // this.tempDetails = details;
    };

    const goForgotPassword = () => {
      window
        .open(getLoginPageURL() + 'forgot-password?type=patient', '_blank')
        .focus();
    };

    const goLogin = () => {
      if (token) {
        go.selection(orgId);
      }
    };

    const openGuardian = () => {
      go.guardianDetails(orgId);
    };

    const onPatientValid = isValid => {
      setPatientValid(isValid);
    };

    const onGuardianValid = isValid => {
      setGuardianValid(isValid);
    };

    const notSupportedComponent = (
      <div className={styles.background}>
        <div className={styles.container}>
          <div className={styles.headerContainer}>
            <Arrow
              className={styles.arrow}
              onClick={() => go.practiceProfile(orgId)}
            />
            <Cross
              className={styles.cross}
              onClick={() => go.practiceProfile(orgId)}
            />
          </div>
          <div className={styles.welcomeTop}>Tēnā koe</div>
          <div className={styles.welcomeBottom}>Welcome To Vensa</div>
          <div className={styles.welcomeBottom}>
            Mobile view is not supported.
          </div>
          <div className={styles.disclaimer}>
            If this is a medical emergency, please call 111 for an ambulance.
          </div>
        </div>
      </div>
    );

    const selectionComponent = (
      <div className={styles.background}>
        <div className={styles.container}>
          <div className={styles.headerContainer}>
            <Arrow
              className={styles.arrow}
              onClick={() =>
                token ? go.practiceProfile(orgId) : go.welcome(orgId)
              }
            />
            <Cross
              className={styles.cross}
              onClick={() => go.practiceProfile(orgId)}
            />
          </div>
          <PatientSelection
            login={login}
            goAfterLogin={goLogin}
            goForgotPassword={goForgotPassword}
            goToPatientDetails={() => {
              go.details(orgId);
            }}
            addPatientDetails={addPatientDetailsPatch}
          />
        </div>
      </div>
    );

    const loginComponent = (
      <div className={styles.background}>
        <div className={styles.container}>
          <div className={styles.headerContainer}>
            <Arrow className={styles.arrow} onClick={() => go.welcome(orgId)} />
            <Cross
              className={styles.cross}
              onClick={() => go.practiceProfile(orgId)}
            />
          </div>
          <div className={styles.welcome}>Welcome back!</div>
          <SignInForm
            login={login}
            goAfterLogin={goLogin}
            goForgotPassword={goForgotPassword}
            goToPatientDetails={() => {
              go.details(orgId);
            }}
          />
        </div>
      </div>
    );

    const detailsComponent = (
      <div className={styles.background}>
        <div className={styles.container}>
          <div className={styles.headerContainer}>
            <Arrow
              className={styles.arrow}
              onClick={() => (token ? go.selection(orgId) : go.welcome(orgId))}
            />
            <Cross
              className={styles.cross}
              onClick={() => go.practiceProfile(orgId)}
            />
          </div>
          <PatientDetails
            onValid={onPatientValid}
            openGuardianDetails={openGuardian}
            addDetails={addPatientDetailsPatch}
            isLoggedIn={!!token}
            hideTnC={() => {
              setShowTnC(false);
            }}
            popUpOpen={false} //{this.props.popUpOpen}
            patientDetails={patientDetails}
          />
          {showTnC && !token && (
            <TnC
              className={styles.condition}
              newStyle={true}
              error={''}
              onClick={() => {}}
            />
          )}
          <div className={styles.buttons}>
            {!token && (
              <div className={styles.loginText}>
                Already with us?
                <button
                  className={styles.loginLink}
                  onClick={() => go.login(orgId)}
                >
                  Log In
                </button>
              </div>
            )}
            <CtaButton
              onClick={() => {
                patientReady();
                go.practiceProfile(orgId);
              }}
              active={patientValid}
              isProcessing={false}
              style={{
                position: 'absolute',
                minWidth: '60px',
                minHeight: '60px',
                bottom: '20px',
                right: '30px',
              }}
            />
          </div>
        </div>
      </div>
    );

    const guardianComponent = (
      <div className={styles.background}>
        <div className={styles.container}>
          <div className={styles.headerContainer}>
            <Arrow className={styles.arrow} onClick={() => go.details(orgId)} />
            <Cross
              className={styles.cross}
              onClick={() => go.practiceProfile(orgId)}
            />
          </div>

          <GuardianDetails
            onValid={onGuardianValid}
            openGuardianDetails={() => {}}
            addDetails={addGuardianDetailsPatch}
            isLoggedIn={!!token}
            hideTnC={() => {}}
            popUpOpen={false} //{this.props.popUpOpen}
            hasGuardian={false}
            patientDetails={guardianDetails}
          />
          <TnC
            className={styles.condition}
            newStyle={true}
            error={''}
            onClick={() => {}}
          />
          <div className={styles.buttons}>
            <div className={styles.loginText}>
              Already with us?
              <button
                className={styles.loginLink}
                onClick={() => go.login(orgId)}
              >
                Log In
              </button>
            </div>
            <CtaButton
              onClick={() => {
                patientReady();
                go.practiceProfile(orgId);
              }}
              active={guardianValid}
              isProcessing={false}
              style={{
                position: 'absolute',
                minWidth: '60px',
                minHeight: '60px',
                bottom: '20px',
                right: '30px',
              }}
            />
          </div>
        </div>
      </div>
    );

    const welcomeComponent = (
      <div className={styles.background}>
        <div className={styles.container}>
          <div className={styles.headerContainer}>
            <Cross
              className={styles.crossRight}
              onClick={() => go.practiceProfile(orgId)}
            />
          </div>
          <div className={styles.welcomeTop}>Tēnā koe</div>
          <div className={styles.welcomeBottom}>Welcome To Vensa</div>
          <button
            className={styles.newButton}
            onClick={() => go.details(orgId)}
          >
            I&#39;m new to Vensa
          </button>
          <button
            className={styles.loginButton}
            onClick={() => go.login(orgId)}
          >
            Log In
          </button>
          <div className={styles.disclaimer}>
            If this is a medical emergency, please call 111 for an ambulance.
          </div>
        </div>
      </div>
    );

    const comp = () => {
      if (isDesktop()) {
        switch (type) {
          case 'login':
            return (
              <DesktopPopUp
                large={true}
                toggle={() => go.practiceProfile(orgId)}
              >
                {loginComponent}
              </DesktopPopUp>
            );
          case 'details':
            return (
              <DesktopPopUp
                large={true}
                toggle={() => go.practiceProfile(orgId)}
              >
                {detailsComponent}
              </DesktopPopUp>
            );
          case 'welcome':
            return (
              <DesktopPopUp
                large={true}
                toggle={() => go.practiceProfile(orgId)}
              >
                {welcomeComponent}
              </DesktopPopUp>
            );
          case 'guardian':
            return (
              <DesktopPopUp
                large={true}
                toggle={() => go.practiceProfile(orgId)}
              >
                {guardianComponent}
              </DesktopPopUp>
            );
          case 'selection':
            return (
              <DesktopPopUp
                large={true}
                toggle={() => go.practiceProfile(orgId)}
              >
                {selectionComponent}
              </DesktopPopUp>
            );
          default:
            return (
              <DesktopPopUp
                style={{ width: '500px', height: '600px' }}
                toggle={() => go.practiceProfile(orgId)}
              >
                {notSupportedComponent}
              </DesktopPopUp>
            );
        }
      }

      return notSupportedComponent;
    };

    return comp();
  },
);

const mapStateToProps = state => ({
  token: state.loginReducer.token,
  practice: state.practiceProfileReducer.profile,
  user: state.profileReducer.profile,
  error: state.practiceProfileReducer.error,
  patientDetails: state.patientDetailsReducer.patientDetails,
  guardianDetails: state.guardianDetailsReducer,
  isLoggedIn: state.loginReducer.token !== null,
});

const mapDispatchToProps = dispatch => ({
  addPatientDetails: bindActionCreators(patientActions.addDetails, dispatch),
  addGuardianDetails: bindActionCreators(guardianActions.addDetails, dispatch),
  patientReady: bindActionCreators(patientActions.isReady, dispatch),
  login: bindActionCreators(loginActions.login, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginDetailsPopup);
